/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")


  
    
export interface API47874Item {
  
  /** 项目编号 */
  projectNo?: string;
  
  /** 项目计划编号 */
  planNo?: string;
  
  /** 项目标题 */
  title?: string;
  
  /** 状态：1未开始2进行中3已完成 */
  status?: number;
  
  /** 合并状态：1:未开始;2:进行中;3:已关闭;5:已完成 */
  combStatus?: number;
  
  /** 项目负责人 */
  projectLeader?: string;
  
  /** 项目负责人编号 */
  projectLeaderNo?: string;
  
  /** 项目负责人头像 */
  projectLeaderAvatar?: string;
  
  /** 执行人列表 ,WorkTaskExecutorResult */
  taskExecutorList?: API47874Item[];
  
  /** 里程牌比重 */
  percent?: number;
  
  /**  */
  percentDou?: any;
  
  /** 里程牌比重 */
  percentStr?: string;
  
  /** 项目进度 */
  process?: number;
  
  /**  */
  processDou?: any;
  
  /** 项目进度 */
  processStr?: string;
  
  /** okr进度 */
  okrProcess?: number;
  
  /** okr进度 */
  okrProcessStr?: string;
  
  /** 关联的okr编号 */
  okrNo?: string;
  
  /** 关联的上级Okr编号 */
  parentOkrNo?: string;
  
  /** 计划开始时间 */
  planStartDate?: any;
  
  /** 计划结束时间 */
  planEndDate?: any;
  
  /** 里程牌说明 */
  remark?: string;
  
  /** 前置项目名称 */
  preProjectName?: string;
  
  /** 前置项目编号 */
  preProjectNo?: string;
  
  /** 前置里程牌编号 */
  preMilestoneNo?: string;
  
  /** 前置里程牌名称 */
  preMilestoneName?: string;
  
  /** 优先级(1:较低,2:普通,3:紧急,4:非常紧急),详见TaskPriorityEnum */
  taskPriority?: number;
  
  /** 任务列表-第一个进行中的里程碑下的任务列表 ,ProjectTaskResp */
  taskList?: API47874Item[];
  
  /** 权限 ,ProjectPlanAuthResp */
  authorizationResp?: any;
  
};
    
  



export interface API47874Req {
  
  /** 项目id */
  projectNo?: string;
    
  /** 名称 */
  titleLike?: string;
    
  /**  */
  pageSize?: string;
    
  /**  */
  pageIndex?: string;
    
  /**  */
  rowId?: string;
    
  /**  */
  jumpType?: string;
    
  /**  */
  searchCount?: string;
    
  /**  */
  orderObjects?: string;
    
};



export interface API47874Res {
  /** T  */
  list?: API47874Item[];
  /**   */
  totalNumber?: any;
  /**   */
  totalPage?: any;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: any;
  /**   */
  pageIndex?: any;
  
};


// 47874 项目计划分页列表

export interface IUseGetAPI47874Return {
  /** 项目计划分页列表: 接口请求状态 */
  isAPI47874Loading: boolean;
  /** 项目计划分页列表: 接口请求返回数据 */
  dataAPI47874: API47874Res;
  /**  项目计划分页列表: 接口数据请求方法 */
  fetchAPI47874Data:  (inputs: API47874Req, config?: YWRequestConfig) => Promise<API47874Res>;
  /** 项目计划分页列表: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI47874 = ():IUseGetAPI47874Return => {
  let isMount = true;
  const [isAPI47874Loading, setIsAPI47874Loading] = useState(false);
  const [dataAPI47874, setDataAPI47874] = useState<API47874Res>({} as API47874Res);
  const requestUrl = `${basePath}/corp-admin/project/plan/page`;

  const fetchAPI47874Data = async (inputs: API47874Req, config?: YWRequestConfig): Promise<API47874Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API47874Req>) || {}) as API47874Req;
    
  
    if ( isMount ) {
      setIsAPI47874Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API47874Res>(`${basePath}/corp-admin/project/plan/page?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI47874(res || {} as API47874Res);
        setIsAPI47874Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI47874Loading(false);
      }
      return false as unknown as API47874Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI47874Loading,
    dataAPI47874,
    fetchAPI47874Data,
    requestUrl,
  }
}

